import {
  CREATEPRODUCTNOTIFICATION,
  GETPRODUCTNOTIFICATION,
  UPDATEPRODUCTNOTIFICATION,
  DELETEPRODUCTNOTIFICATION,
} from "../actions/types";

const initialState = {
  productDesignationList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEPRODUCTNOTIFICATION:
      return {
        ...state,
        productnotificationSaveStatus: action.payload.success,
      };
    case GETPRODUCTNOTIFICATION:
      return {
        ...state,
        productnotificationList: action.payload.data,
      };
    case UPDATEPRODUCTNOTIFICATION:
      return {
        ...state,
        productnotificationUpdateStatus: action.payload.success,
      };
    case DELETEPRODUCTNOTIFICATION:
      return {
        ...state,
        productnotificationDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
